module.exports = __webpack_public_path__ + "img/ic-acessibilidade-diminuir-texto.aa64ce46.svg";